import Image from "@/components/common/Image";
import { Link } from "react-router-dom";

interface EnterpriseApp {
  logo: string;
  name: string; // Still keeping this in the interface for data structure consistency
}

interface EnterpriseEcosystemProps {
  title: string;
  description: string;
  applications: EnterpriseApp[];
  extraText?: string;
}

export const EnterpriseEcosystem: React.FC<EnterpriseEcosystemProps> = ({
  title,
  description,
  applications,
  extraText
}) => {
  const handleNavigate = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 px-6 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-4">{title}</h2>
        <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto">
          {description}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {applications.map((app, index) => (
            <div
              key={index}
              className="rounded-xl p-4 flex items-center justify-center aspect-square "
            >
              <div className="w-full h-full flex items-center justify-center">
                <Image
                  src={app.logo}
                  alt={`${app.name} logo`}
                  style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Link
            to="/integrations"
            className="text-blue-600 font-medium hover:text-blue-800 text-lg transition-colors"
            onClick={handleNavigate}
          >
            View more integrations →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseEcosystem;